import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import dayjs from 'dayjs';
import 'dayjs/locale/es';

import en from './locales/en.json';
import es from './locales/es.json';
import { DEFAULT_LANGUAGE, LOAD_SEARCH_PARAMS } from './constants';

// Mirrors UweStudioFrontend's i18n setup (react-i18next). Keys are the natural
// -language source string, so `keySeparator`/`nsSeparator` are disabled — keys
// contain dots, colons and spaces and must be treated literally.
export const LOCALE_STORAGE_KEY = 'uwe-locale';

function initialLanguage() {
  // `?lang=` wins (deep-link / QA), then the persisted choice, then the env
  // default. Anything outside the known set falls back to the env default.
  const fromUrl = LOAD_SEARCH_PARAMS.lang;
  if (fromUrl === 'en' || fromUrl === 'es') return fromUrl;
  const saved = typeof localStorage !== 'undefined' ? localStorage.getItem(LOCALE_STORAGE_KEY) : null;
  if (saved === 'en' || saved === 'es') return saved;
  return DEFAULT_LANGUAGE === 'es' ? 'es' : 'en';
}

const lng = initialLanguage();

i18n.use(initReactI18next).init({
  react: {
    useSuspense: false
  },
  resources: {
    en: { translation: en },
    es: { translation: es },
  },
  lng,
  fallbackLng: 'en',
  keySeparator: false,
  nsSeparator: false,
  interpolation: {
    escapeValue: false,
  },
});

dayjs.locale(lng);

export default i18n;
